import { createSlice } from '@reduxjs/toolkit';
const initialState = () => {
    return {
        reports:[],
        errors:[],
        reportCompanies:[],
        dimensions:[],
        singlereport:[],
        latestReportDate: null,
    };
  };

const rsReportSlice = createSlice({
  name: 'rsReport',
  initialState:initialState(),
  reducers: {
    setReports(state, action) {
      state.reports = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setReportCompanies(state, action) {
        state.reportCompanies = action.payload;
      },
    setDimensions(state, action) {
      state.dimensions = action.payload;
    },
    setSingleReport(state, action) {
      state.singlereport = action.payload;
    },
    setLatestReportDate(state, action) {
      state.latestReportDate = action.payload;
    },

  },
});

export const {
  setReports,
  setErrors,
  setReportCompanies,
  setDimensions,
  setSingleReport,
  setLatestReportDate,
  
} = rsReportSlice.actions;
export const rsReport=rsReportSlice.reducer;